import React from 'react'
import Drawer from '@mui/material/Drawer'
import styled from '@mui/system/styled'
import { Button } from '@mui/material'

export const StyledDrawer = styled((props) => (
  <Drawer anchor="right" {...props} />
))(({ theme }) => ({
  '& .MuiBox-root#header': {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 0',
    margin: `0 ${theme.spacing(2)}`,
  },
  '& .MuiDivider-root#divider': {
    marginBottom: theme.spacing(2),
    borderColor: theme.palette?.other?.divider,
  },
  '& .MuiBox-root#body': {
    width: 360,
    padding: `0 ${theme.spacing(2)}`,
  },
  '& ::-webkit-scrollbar': { display: 'none' },
}))

export const StyledButton = styled(Button)(({ theme }) => ({
  '@media (hover: none)': {
    ':hover': {
      background: 'unset',
      color: theme.palette.primary.main,
    },
    ':hover:after': {
      opacity: 0,
    },
  },
}))
